//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('collections', {
//        templateUrl: 'views/components/views/collections/collections.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {
//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_collections_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setLoadDataFunction({
//                    method: 2723,
//                    parameters: {}
//                }).setCustomToolbarButtons([{
//                    name: 'collections_new',
//                    text: 'collections_new',
//                    func: () => stateService.go('collection', { collection_keyno: '0' }),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }]);
//        }]
//    });
//})();
